import { Link } from 'react-router-dom';
import type { Topic } from '@/types/content';

const topicTone: Record<Topic['color'], { bubble: string; heat: string; ring: string }> = {
  primary: {
    bubble: 'bg-primary-100 text-primary-700',
    heat: 'text-primary-600',
    ring: 'group-hover:border-primary-200',
  },
  accent: {
    bubble: 'bg-accent-100 text-accent-900',
    heat: 'text-accent-700',
    ring: 'group-hover:border-accent-300',
  },
  secondary: {
    bubble: 'bg-secondary-100 text-secondary-900',
    heat: 'text-secondary-700',
    ring: 'group-hover:border-secondary-300',
  },
};

export default function TopicCard({ topic }: { topic: Topic }) {
  const tone = topicTone[topic.color];

  return (
    <Link
      to={`/topics?topic=${topic.slug}`}
      className={`group flex flex-col rounded-card border border-background-200 bg-background-50 p-5 transition-colors ${tone.ring}`}
    >
      <div className="flex items-start justify-between">
        <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${tone.bubble}`}>
          <i className={topic.icon} />
        </span>
        <span className={`font-heading text-lg tabular-nums ${tone.heat}`}>{topic.heat}</span>
      </div>
      <h3 className="mt-4 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
        {topic.name}
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.description}</p>
      <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5 text-xs text-foreground-500">
        <span>收录 {topic.articleCount} 篇速报</span>
        <span className="inline-flex items-center gap-1 font-medium text-foreground-700 transition-colors group-hover:text-primary-600">
          进入话题
          <i className="ri-arrow-right-line" />
        </span>
      </div>
    </Link>
  );
}